<div *ngIf="workOrders?.length > 0">
  <mat-card appearance="outlined">
    <mat-card-header>
      <mat-card-title>
        <ng-container *ngIf="isVendor; else notVendor">
          {{ 'SALES_ORDER_SUMMARY.TITLE' | translate }}
        </ng-container>
        <ng-template #notVendor>
          {{ 'SALES_ORDER_SUMMARY.TITLE_NON_VENDOR' | translate }}
        </ng-template>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content *ngIf="includeThermometer" class="thermometer-container">
      <mat-progress-bar
        class="progress-bar"
        mode="determinate"
        color="primary"
        [value]="thermometerProgress"
      ></mat-progress-bar>
      <div class="thermometer-suffix">
        {{ thermometerSuffix }}
      </div>
    </mat-card-content>
    <mat-list *ngIf="workOrders?.length > 0">
      <ng-container *ngFor="let wo of workOrders">
        <mat-list-item *ngIf="wo.hasForm">
          <glxy-avatar matListItemIcon [name]="wo.appName" [src]="wo?.appIconUrl"></glxy-avatar>
          <div matListItemTitle>
            <ng-template #appName>
              <span>{{ wo.appName }}</span>
              <span *ngIf="(isMobile$ | async) === false && isVendor" class="lighter-text">{{ wo.workOrderId }}</span>
            </ng-template>
            <ng-container>
              <a
                *ngIf="wo?.workOrderLandingPageUrl || wo?.workOrderLandingPageRouterLinkUrl"
                (click)="handleChevronClick(wo)"
              >
                <ng-container *ngTemplateOutlet="appName"></ng-container>
              </a>
            </ng-container>
          </div>
          <div matListItemMeta>
            <work-order-status-badge [value]="wo?.workOrderStatus" [persona]="persona"></work-order-status-badge>
          </div>
        </mat-list-item>
      </ng-container>
    </mat-list>
  </mat-card>
</div>
